import React from "react";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {
  return (
    <div className="payment-success-body">
      <div className="checkmark"></div>
      <div className="message">Payment Successful!</div>
      <div className="subtext">Thank you for your payment.</div>
    </div>
  );
};

export default PaymentSuccess;
